import { render, staticRenderFns } from "./CancelInfoIcon.vue?vue&type=template&id=21ac70b4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ac70b4')) {
      api.createRecord('21ac70b4', component.options)
    } else {
      api.reload('21ac70b4', component.options)
    }
    module.hot.accept("./CancelInfoIcon.vue?vue&type=template&id=21ac70b4", function () {
      api.rerender('21ac70b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CancelInfoIcon.vue"
export default component.exports